import axios from "axios";

import { _t } from "@/lib/i18n";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token if present (as fallback to cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tc_access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public API instance (no auth) — used for verification endpoint
export const publicApi = axios.create({
  baseURL: API,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || _t("Si è verificato un errore");
  if (detail === "EMAIL_NOT_VERIFIED") return _t("Conferma la tua email per continuare: apri il link che ti abbiamo inviato o richiedine uno nuovo.");
  if (typeof detail === "string") return _t(detail);
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
